import React from "react";
import { PrivacyCenterRequestFormSettingsRowProps } from "./PrivacyCenterRequestFormSettingsRow";
import { PrivacyCenterRequestFormSettingsRow } from "./PrivacyCenterRequestFormSettingsRow";

export function PrivacyCenterOptOutSettingsRow(props: PrivacyCenterRequestFormSettingsRowProps) {
  return (
    <>
      <PrivacyCenterRequestFormSettingsRow title="Opt-Out Form" {...props} />
    </>
  );
}
